import { render, staticRenderFns } from "./trandmarkdetaliy.vue?vue&type=template&id=2d8c5274&scoped=true&"
import script from "./trandmarkdetaliy.vue?vue&type=script&lang=js&"
export * from "./trandmarkdetaliy.vue?vue&type=script&lang=js&"
import style0 from "./trandmarkdetaliy.vue?vue&type=style&index=0&id=2d8c5274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c5274",
  null
  
)

export default component.exports